import { useState } from "react";
// Components
import ReturnAddressForm from "./ReturnAddressForm";
// MUI
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function ReturnAddressChangeDialog({ setReturnData, setValue }) {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        sx={{ mt: 2 }}
        onClick={handleClickOpen}
      >
        Change
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth={"lg"}>
        <DialogTitle>Change Address</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Use the form below to change the collection address.
          </DialogContentText>
          <ReturnAddressForm
            closeDialog={handleClose}
            setReturnData={setReturnData}
            setValue={setValue}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
